module.exports = __webpack_public_path__ + "img/pdf.af6dbff9.svg";